var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loading-screen",attrs:{"element-loading-text":"页面加载中……","element-loading-background":"rgba(255,255,255, 0.5)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }